import * as actionTypes from "../constants";


export const requestStart = () => {
  return {
    type: actionTypes.AUTH_REQUEST_START
  };
};

export const requestSuccess = () => {
  return {
    type: actionTypes.AUTH_REQUEST_SUCCESS
  };
};

export const requestFail = (error) => {  
  return {
    type: actionTypes.AUTH_REQUEST_FAIL,
    error: error.response
  };
};

export const requestUserSuccess = (userData) => {
  return {
    type: actionTypes.AUTH_USER_REQUEST_SUCCESS,
    user: userData
  };
};

export const requestLogoutSuccess = () => {
  return {
    type: actionTypes.AUTH_LOGOUT_REQUEST_SUCCESS
  }
}

export const clearError = () => {
  return {
    type: actionTypes.AUTH_CLEAR_ERROR
  }
}

export const tokenRefreshSuccess = (tokens) => {
  return {
    type: actionTypes.AUTH_TOKEN_REFRESH_SUCCESS,
    tokens: tokens
  }
}
